<div class="d-flex flex-row align-items-center justify-content-center h-100 container">

  <div class="col-1 w-50">
    <div class="intro-home">
      <div class="row d-flex justify-content-left text-mobile">
        <h1 class="accent text-left m-h1 line-height-h1">{{ 'b2c.IDS_TITLE_B2C' | translate }}</h1>
      </div>
      <!--<hr class="divider">-->
      <div class="row d-flex justify-content-left text-mobile">
        <h4 class="font-weight-normal m-0 text-left line-height-h4">
          <span [innerHTML]="'b2c.IDS_SUBTITLE_B2C' | translate"></span><br />
          <a *ngIf="sharewithInstaller" class="link-underline" (click)='goToSharePage()'> {{ 'b2c.IDS_SUBTITLELINK_B2C' | translate }}</a></h4>
      </div>
      <div class="row d-flex justify-content-center button-margin button-mobile">
        <button mat-flat-button color="primary" class="cta-inverted" (click)= 'btnOpenQuotation()'>
          <span class="text-uppercase">
            {{ 'b2c.IDS_OPENQUOTATION' | translate }}
          </span>
        </button>
        <button mat-flat-button color="primary" class="cta" [eventTracker]='{"category":"quote_new", "label":"quote_new", "action":"click"}' (click)= 'btnNewQuotation()'>
          <span class="text-uppercase">
            {{ 'b2c.IDS_NEWQUOTATION' | translate }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <div class="col-2 w-50">
    <div class="videocontainer row d-flex justify-content-center">
      <!-- in attesa del video da mettere in loop-->

      <!--<div class="row d-flex justify-content-center">-->
        <video [autoplay]="true" [muted]="true" playsinline loop>
            <source src="{{ videoURL }}" type="video/mp4">
            Your browser does not support the video tag.
        </video>
     <!--</div>-->

    </div>
  </div>

</div>
